module.exports = __webpack_public_path__ + "static/media/g-4-c.a8c0d1ea.jpg";